<ng-container *ngIf="formPrincipal">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">{{ modelRecived ? 'Editar Liquidación' : 'Agregar Liquidación' }}</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <button class="btn-new" mat-raised-button color="accent" appPermissionControl="P141B0002" (click)="modelRecived ? update(form.value) : create(form.value)">
          <mat-icon>save</mat-icon>
          {{ modelRecived ? 'Actualizar' : 'Guardar' }}
        </button>
        <button class="btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P141B0001"><mat-icon>arrow_back</mat-icon>Cancelar</button>
      </div>
    </div>
  </div>

  <form class="mt-5" [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P141F0001">
    <div class="form-row">
      <!-- Variable -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Variable Id</label>
        <input id="numVar" class="form-control" formControlName="numVar" type="number" [readonly]="modelRecived" required appPermissionControl="P141K0001" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Descripción</label>
        <input class="form-control" formControlName="descripcion" type="text" required appPermissionControl="P141K0002" />
      </div>

      <div class="line-break"></div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Concepto</label>
        <select class="form-control" formControlName="concepto" required appPermissionControl="P141K0003">
          <option value>-- Seleccione --</option>
          <option *ngFor="let concepto of conceptos" [value]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
        </select>
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Se Aplica a</label>
        <select class="form-control" formControlName="conceptoAdicional" appPermissionControl="P141K0004">
          <option value>-- Seleccione --</option>
          <option *ngFor="let concepto of conceptos" [value]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
        </select>
      </div>

      <div class="line-break"></div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Estimación Para</label>
        <select class="form-control" formControlName="amortInf" appPermissionControl="P141K0005">
          <option value>-- Seleccione --</option>
          <option *ngFor="let element of estimate" [value]="element.iValor">{{ element.iValor }} | {{ element.sEtiqueta }}</option>
        </select>
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Superior</label>
        <input class="form-control" placeholder="31" formControlName="amortSup" type="number" required appPermissionControl="P141K0006" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Valor Fijo</label>
        <input class="form-control" placeholder="0.2" formControlName="valorFijo" type="number" appPermissionControl="P141K0007" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Porcentaje </label>
        <select class="form-control" formControlName="claveTasa" required appPermissionControl="P141K0008">
          <option value>-- Seleccione --</option>
          <option *ngFor="let tasa of tasas" [value]="tasa.clave">{{ tasa.clave }} | {{ tasa.descripcion }}</option>
        </select>
      </div>
    </div>
  </form>
</ng-container>
